import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useThemeMode } from "hooks/useThemeMode";
import { getSwitchBg, getSwitchColor } from "helpers/themeColors";
import { Grid, FormControlLabel, Typography } from "@mui/material";
import { green, red, blue } from "@mui/material/colors";
import { NoStatusSwitch, ClosedSwitch, OpenSwitch } from "./customSwitches";
import { useSearch } from "hooks/useSearch";
import { filtersRoutes } from "redux/actions/routesStatus/routesStatusAction";

const style = {
  width: "100%",
  padding: "2px 8px",
  borderRadius: 4,
  marginLeft: 0,
  transition: "0.3s ease",
};

export const FilterSwitches = ({ tableKey = '' }) => {
  const { temp: { OPEN, NO_STATUS, CLOSED }, status } = useSelector(({ routesStatus }) => routesStatus);
  const { isDark } = useThemeMode();
  const dispatch = useDispatch();
  const {restoreTable} = useSearch()
  const handleFilters = (e, field) => {
    dispatch(filtersRoutes(field))
    restoreTable(tableKey)
  };

  return (
    <Grid container spacing={1} style={{ marginTop: 8 }}>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <OpenSwitch
              checked={status.OPEN}
              onClick={(e) => handleFilters(e, "open")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(green, isDark),
              }}
            >
              <span style={{ fontWeight: "bold", marginRight: 20 }}>
                {OPEN.length}
              </span>
              - Abierta
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(green, isDark),
            backgroundColor: getSwitchBg(green, status.OPEN, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <NoStatusSwitch
              checked={status.NO_STATUS}
              onClick={(e) => handleFilters(e, "no_status")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(red, isDark),
              }}
            >
              <span style={{ fontWeight: "bold", marginRight: 20 }}>
                {NO_STATUS.length}
              </span>
              - Sin Status
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(red, isDark),
            backgroundColor: getSwitchBg(red, status.NO_STATUS, isDark),
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControlLabel
          labelPlacement="start"
          control={
            <ClosedSwitch
              checked={status.CLOSED}
              onClick={(e) => handleFilters(e, "closed")}
            />
          }
          label={
            <Typography
              component="p"
              variant="h5"
              style={{
                color: getSwitchColor(blue, isDark),
              }}
            >
              <span style={{ fontWeight: "bold", marginRight: 20 }}>
                {CLOSED.length}
              </span>
              - Cerrada
            </Typography>
          }
          style={{
            ...style,
            color: getSwitchColor(blue, isDark),
            backgroundColor: getSwitchBg(blue, status.CLOSED, isDark),
          }}
        />
      </Grid>
    </Grid>
  );
};
